import { useEffect, useState } from "react";

export function usePreloadedImage(url: string | undefined): string | undefined {
    const [loadedUrl, setLoadedUrl] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (!url) return;

        let cancelled = false;
        const image = new Image();
        image.onload = () => {
            if (!cancelled) setLoadedUrl(url);
        };
        image.src = url;

        return () => {
            cancelled = true;
            image.onload = null;
        };
    }, [url]);

    return loadedUrl === url ? url : undefined;
}
